<template>
    <a
        v-if="link"
        :href="link"
        class="group relative mr-6 flex h-10 w-10 items-center justify-center rounded-full text-md font-bold uppercase tracking-widest lg:h-18 lg:w-18">
        <lz-icon name="cart" class="h-5 w-5 shrink-0 fill-current lg:h-8 lg:w-8" />
        <div
            class="absolute right-0 top-0 flex h-4.5 w-4.5 items-center justify-center rounded-full text-sm text-current lg:right-3 lg:top-3">
            {{ quantity }}
        </div>
    </a>
</template>

<script setup lang="ts">
import {computed, inject, onMounted, ref} from 'vue';
import LzIcon from '@/components/base/LzIcon.vue';
import { getCookie } from '@/utils';

const site = inject('siteName') as string;
const link = computed(() => (process.env.VUE_APP_FRONTEND_URL || '') + `/shop/${site}/cart/`);
const quantity = ref(0);

onMounted(async () => {
    const cart = await getCart();
    if (cart) {
        quantity.value = cart.totalQuantity;
    }
});

async function getCart() {
    let headers: Record<string, string> = {
        'Content-Type': 'application/json',
    };
    const token = getCookie('authToken');
    headers = {
        ...headers,
        'Authorization': `Bearer ${token}`
    };
    const requestOptions = {
        method: 'POST',
        headers,
        body: JSON.stringify({
            query: `{
              activeOrder {
                totalQuantity
              }
            }`
        })
    };
    let response: Response = new Response();
    try {
        response = await fetch(`${process.env.VUE_APP_SHOP_URL}/shop-api`, requestOptions);
        const { data, errors } = await response.json();
        if (errors && !data) {
            // e.g. API access related errors, like auth issues.
            throw new Error(errors[0].message);
        }
        return data.activeOrder;
    } catch (error) {
        console.error(
            `Could not fetch from ${process.env.VUE_APP_SHOP_URL}/shop-api. Reason: ${error}`
        );
    }
}
</script>
